import { useAuthStore } from '~/stores/authStore'

export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore()

    // Skip middleware on server-side if needed, or handle via cookies
    // For now, we rely on client-side state for simple protection
    if (import.meta.server) return

    // Immediately handle signout securely before hydrating layout
    if (to.path === '/logout') {
        const userCookie = useCookie('user')
        if (userCookie.value) userCookie.value = null

        authStore.clearUser()

        // Let Firebase clear session without blocking routing
        if (import.meta.client) {
            import('firebase/auth').then(({ getAuth, signOut }) => {
                const auth = getAuth()
                if (auth) signOut(auth).catch(() => { })
            })
        }

        return navigateTo('/login')
    }

    const isPublicPage = to.path === '/login' || to.path === '/signup' || to.meta.unauthenticatedOnly === true
    const requiresAuth = to.meta.authenticated !== false && !isPublicPage

    // If page requires auth and user is not logged in, redirect to login
    if (requiresAuth && !authStore.isLoggedIn) {
        return navigateTo({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    }

    // If user is logged in and tries to access public only pages (login/signup)
    if (isPublicPage && authStore.isLoggedIn) {
        return navigateTo('/')
    }
})
